import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import useDashboard from './useDashboard';

const TopHiringCompanies = () => {
    const { state } = useContext(SmartContext);
    const { getTopHiringCompanies } = useDashboard();

    useEffect(() => {
        getTopHiringCompanies();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.topHiringCompanies))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <> 
            <div className="row g-3">
                {state?.data?.dashboardData?.topHiringCompanies?.map((company: any, index: any) => {
                return (<>
                    <div className="col-12">
                        <div className="row g-4 align-items-center">
                            <div className="col-auto font-20 font-600">
                                {index + 1}
                            </div>
                            <div className="col">
                                <div className="row g-3 align-items-center">
                                    <div className="col-auto">
                                        <img src={company.logo} width="34" className="img-fluid" alt="" />
                                    </div>
                                    <div className="col">
                                        <div className="font-16 font-600">
                                            {company.label}</div>
                                        <div className="font-14 font-400">
                                            {company.job_count} Job(s) | {company.applied_count} Application(s)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    {index !== state?.data?.dashboardData?.topHiringCompanies.length - 1 && (
                        <div className="col-12">
                            <hr className="m-0" />
                        </div>
                    )}
                </>)
                })}

            </div>
        </>
    );
};

export default TopHiringCompanies;
